import { getScrollTop } from './getScrollTop';
import { scrollToPos } from './scrollToPos';

export function scrollToTopOf(node: HTMLElement | undefined, offset: number = 0, duration: number = 0): Promise<void> {
  if (!node) {
    return Promise.resolve();
  }

  const { top } = node.getBoundingClientRect();
  const scrollTop = getScrollTop();

  return scrollToPos(scrollTop + top + offset, duration);
}
